import { useParams } from 'react-router-dom';

import FileContextMenu from '../../components/Files/FileContextMenu';
import FilesContextMenu from '../../components/Files/FilesContextMenu';
import FilesHeader from '../../components/Files/FilesHeader';
import FilesList from '../../components/Files/FilesList';
import FilesTable from '../../components/Files/FilesTable';
import { FilesTableEnum } from '../../enums/FilesTableEnum';
import useFiles from '../../hooks/useFiles';
import { useFilesTableColumns } from '../../hooks/useFilesTableColumns';
import ContentLayout from '../../layouts/ContentLayout';

export const TrashFiles = () => {
  const params = useParams();

  const {
    files,
    isLoading,
    isNavigating,
    filters,
    handleFiltersChange,
    rowSelection,
    setSelectedTableKeys,
    handleRowContextMenu,
    handleTableChange,
    handleRowClick,
    handleLoadMore,
    selectedTableKeys,
    breadcrumbItems,
    isFilesListInGridMode,
    setIsFilesListInGridMode,
    isContextMenuVisible,
    setIsContextMenuVisible,
    contextMenuPosition,
    isFilesContextMenuVisible,
    setIsFilesContextMenuVisible,
    filesContextMenuPosition,
    handleEmptyAreaContextMenu,
    handleFileMenuAction,
    selectedFiles,
    handleFileRowClick,
    handleFileRowDoubleClick,
    emptyState,
    topBarFileActions,
    contextMenuFileActions,
    tableScrollY,
    gridScrollY,
    filesOffline,
    handleMoveDraggedFiles,
    activeFiltersCount,
    parentFolder,
  } = useFiles({
    table: FilesTableEnum.Trash,
    folderUid: params?.folderUid,
  });

  const columns = useFilesTableColumns({
    filesOffline,
    handleFileMenuAction,
    handleRowContextMenu,
    selectedTableKeys,
    setSelectedTableKeys,
    table: FilesTableEnum.Trash,
    topBarFileActions,
  });

  return (
    <ContentLayout scrollable={!isFilesListInGridMode}>
      <ContentLayout.Header>
        <FilesHeader
          isLoading={isLoading}
          selectedFiles={selectedFiles}
          selectedTableKeys={selectedTableKeys}
          setSelectedTableKeys={setSelectedTableKeys}
          isFilesListInGridMode={isFilesListInGridMode}
          setIsFilesListInGridMode={setIsFilesListInGridMode}
          onFiltersChange={handleFiltersChange}
          filters={filters}
          handleFileMenuAction={handleFileMenuAction}
          breadcrumbItems={breadcrumbItems}
          section={FilesTableEnum.Trash}
          filesActions={topBarFileActions}
          activeFiltersCount={activeFiltersCount}
          filesCount={files.length}
          parentFolder={parentFolder}
        />
      </ContentLayout.Header>

      <ContentLayout.Content>
        {isFilesListInGridMode ? (
          <FilesList
            files={files}
            isLoading={isLoading}
            handleLoadMore={handleLoadMore}
            scrollHeight={gridScrollY}
            selectedTableKeys={selectedTableKeys}
            setSelectedTableKeys={setSelectedTableKeys}
            handleRowClick={handleRowClick}
            handleRowContextMenu={handleRowContextMenu}
            handleEmptyAreaContextMenu={handleEmptyAreaContextMenu}
            handleRowDoubleClick={handleFileRowDoubleClick}
            handleFileRowClick={handleFileRowClick}
            emptyState={emptyState}
            filesOffline={filesOffline}
            handleMoveDraggedFiles={handleMoveDraggedFiles}
          />
        ) : (
          <FilesTable
            columns={columns}
            emptyState={emptyState}
            files={files}
            handleEmptyAreaContextMenu={handleEmptyAreaContextMenu}
            handleFileRowClick={handleFileRowClick}
            handleFileRowDoubleClick={handleFileRowDoubleClick}
            handleLoadMore={handleLoadMore}
            handleMoveDraggedFiles={handleMoveDraggedFiles}
            handleRowContextMenu={handleRowContextMenu}
            handleTableChange={handleTableChange}
            isLoading={isLoading}
            showLoadingOverlay={isNavigating && files.length > 0}
            rowSelection={rowSelection}
            selectedTableKeys={selectedTableKeys}
            setSelectedTableKeys={setSelectedTableKeys}
            tableScrollY={tableScrollY}
          />
        )}
        <FileContextMenu
          files={selectedFiles}
          isUploadDisabledInCurrentFolder={true}
          position={contextMenuPosition}
          visible={isContextMenuVisible}
          onClose={() => setIsContextMenuVisible(false)}
          onAction={(fileUids, action) => {
            handleFileMenuAction(fileUids, action);
          }}
          filesActions={contextMenuFileActions}
        />
        <FilesContextMenu
          position={filesContextMenuPosition}
          visible={isFilesContextMenuVisible}
          isUploadDisabledInCurrentFolder={true}
          onClose={() => setIsFilesContextMenuVisible(false)}
        />
      </ContentLayout.Content>
    </ContentLayout>
  );
};

export default TrashFiles;
